var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgControl = function SvgControl(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 88 88"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#105880",
    fillRule: "evenodd",
    d: "M48.58 33.99a12.84 12.84 0 1 0-9.16 0v16.43a4.58 4.58 0 1 0 9.16 0V33.99Zm-.78-5.72a7.3 7.3 0 0 1-3.8 1.06A7.33 7.33 0 0 1 36.67 22a7.33 7.33 0 1 1 11.13 6.27Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#105880",
    d: "M51.33 56.83c0-1 .82-1.83 1.84-1.83h3.66a1.83 1.83 0 0 1 0 3.67h-3.66a1.83 1.83 0 0 1-1.84-1.84Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#105880",
    fillRule: "evenodd",
    d: "M33.68 47.67a7.33 7.33 0 0 0-5.7 2.72l-9.65 11.94h51.34L60.02 50.4a7.33 7.33 0 0 0-5.7-2.72v-5.5c3.88 0 7.54 1.75 9.98 4.77l9.65 11.94a5.5 5.5 0 0 1 1.22 3.45v7.34A9.17 9.17 0 0 1 66 78.83H22a9.17 9.17 0 0 1-9.17-9.16v-7.34a5.5 5.5 0 0 1 1.23-3.45l9.64-11.94a12.83 12.83 0 0 1 9.98-4.77v5.5Zm-15.35 22v-1.84h51.34v1.84A3.67 3.67 0 0 1 66 73.33H22a3.67 3.67 0 0 1-3.67-3.66Z",
    clipRule: "evenodd"
  })));
};
export default SvgControl;